import React, { useState,useMemo, forwardRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {  useNavigate } from 'react-router-dom';
import {
  Table,
  Form,
  InputGroup,
  Badge
} from 'react-bootstrap';
import { load_Bugs_list } from '../../../../utils/services';
import Select, { components } from 'react-select';


const Bug_link = (({token, user_id, permission, onSet}) => {
    // --- Estado de filtros/orden/columnas ---
    const navigate = useNavigate();   
    const [searchTerm, setSearchTerm] = useState('');
    const [initialRows, setInitialRows] = useState([]);
     const [productsOptions, setProductsOptions] = useState([]);
         const [selectedProducts, setselectedProducts] = useState([]);

       useEffect(() => {
   
         fetch_Bugs_list();
       },
        []);

    async function fetch_Bugs_list() {
             const jsonResult = await load_Bugs_list(token);
             if (jsonResult==="INVALID"){
               navigate("/");
             }else{
       
              
               const bugList= jsonResult['data'].map((element, index) => {
                   return { id: element.id, 
                      title: element.title, 
                      approach: element.approach,
                      products: element.products,
                      status: element.status,
                      description: element.description,
                      trello_url: element.trello_url,
                      index: index };
                 });

              const uniqueProducts = [...new Set(bugList.flatMap(bug => bug.products))];


              // Transforma cada producto (string) en un objeto { value, label }
              const selectOptionsProducts = uniqueProducts.map(product => {
                return {
                  value: product, // El valor que se enviará en un formulario
                  label: product  // El texto que verá el usuario en el desplegable
                };
              });
               setProductsOptions(selectOptionsProducts);
              
               setInitialRows(bugList);
               
            }
      }


    // --- Filtrado + ordenamiento memoizados ---
    const rows = useMemo(() => {
      let result = initialRows;
  
      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        result = result.filter((r) =>
          Object.values(r).some((v) => String(v).toLowerCase().includes(term))
        );
      }

      if (selectedProducts && selectedProducts.length > 0) {
        result = result.filter(row => 
            // La fila debe tener una propiedad 'products' que sea un array
            // y al menos UNO ('some') de sus productos debe estar incluido
            // en el arreglo 'selectedProducts'.
            row.products && row.products.some(product => selectedProducts.includes(product))
        );
    }
      
  
      return result;
    }, [searchTerm,  initialRows, selectedProducts]);

   const CustomMultiValueLabel = (props) => {
    const { data, innerProps, selectProps } = props;
    const originalLabel = data.label;
    const maxLength = 10; // Define el número máximo de caracteres que quieres mostrar
  
    // Aplica el truncamiento si la etiqueta es más larga que maxLength
    const truncatedLabel = originalLabel.length > maxLength
      ? originalLabel.substring(0, maxLength) + '.'
      : originalLabel;
  
    return (
      <components.MultiValueLabel {...props}>
        {truncatedLabel}
      </components.MultiValueLabel>
    );
  };

    const getProductByValue = (values) => {
    if (!Array.isArray(values)) {
      return []; // Ensure it's always an array for multi-select
    }
    return productsOptions.filter(option => values.includes(option.value));
  };
    const add_linked_strategy = (id, title, urlTrello) => {
      onSet(id, title, urlTrello);
    };

    
   
const getColorForId = (id) => {
  const hue = (id * 41) % 360;
   return `hsl(${hue}, 60%, 50%)`; 
};

    // ---------- UI ----------
    return (
      <div className="container py-4">

        {/* Barra de búsqueda + menús */}
        <div className="row align-items-center py-4">
          <div className="col-lg-4 col-md-12">
            <Form.Control
              placeholder="Buscar nombre..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className='toolbar-control'
            />
          </div>
          <div className="col-lg-6 col-md-12">
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                options={productsOptions}
                isLoading={productsOptions.length === 0}
                // --- Key Change: Add isMulti prop ---
                isMulti
                // --- Key Change: onChange now receives an array of selected options ---
                onChange={(productsOptions) => {
                  // `selectedOptions` will be an array of objects: [{ value: 10, label: 'Stage 10%' }, ...]
                  // Map it to just the values to store in your state
                  const values = productsOptions ? productsOptions.map(option => option.value) : [];
                  setselectedProducts(values); // Update your state with the array of selected values
                }}
                placeholder="Product filter..."
                // --- Key Change: value should now be an array of selected option objects ---
                value={getProductByValue(selectedProducts)}
            components={{
                  MultiValueLabel: CustomMultiValueLabel,
                }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: 100,
                    flex: 1,
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999
                  })
                }}
              />
          </div>
        </div>

        {/* Tabla */}
        <div style={{ height: '400px', overflowY: 'auto' }}> {/* Altura fija y scroll */}
          {/* Añade la clase text-start aquí */}
          <Table hover responsive className="align-middle text-start">
            <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
              <tr >
                  <th role="button">
                    Titulo 
                  </th>
                   <th role="button">
                    Products 
                  </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id} onClick={() => add_linked_strategy(row.id, row.title, row.trello_url)} >
                  <td>{row.title} {row.trello_url && (
                    <a
                      href={row.trello_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <Badge bg="info">Trello</Badge>
                    </a>
                  )}</td>
                  <td>
                  {row.products.map((product, index) => {
                    const dynamicColor = getColorForId(parseInt(index));
                    return (
                       
                   <span
                                          key={index}
                                          className="badge pill chip d-inline-flex align-items-center gap-2 px-3 py-2 fs-8"
                                          style={{ backgroundColor: dynamicColor, cursor: 'pointer' }}
                                      >{product}</span>
                    )}
                  )
                  }

                </td>
              
                
                  

                </tr>

              ))}
              {rows.length === 0 && (
                <tr>
                  {/* También puedes añadir text-start aquí si quieres asegurar la alineación para el mensaje "No results" */}
                  <td colSpan="10" className="text-center py-4 text-start">
                    No results
                  </td>
                </tr>
              )}
              
            </tbody>
          </Table>
        </div>
      </div>
    );
});

export default Bug_link;
